import React from "react";
import { CloseOutlined } from "@ant-design/icons";
import { Button, Tooltip } from "antd";

const GridItemWrapper = ({ item, onRemove, children }) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: 8,
          right: 8,
          zIndex: 100,
        }}
      >
        <Tooltip title="Retirer" placement="bottom">
          <Button
            type="default"
            shape="circle"
            size="small"
            icon={<CloseOutlined />}
            onClick={() => onRemove(item.id)}
          />
        </Tooltip>
      </div>
      {children}
    </div>
  );
};

export default GridItemWrapper;
